export const animationVariant = {
  visible: { x: 0 },
  hidden: { x: '100%' },
};
